<div class="mb-myaccount-backgroundlayer">
  <div class="mb-myaccount-bg-wrapper">
    <div class="mb-myaccount-bg-bubbles-1"></div>
    <div class="mb-myaccount-bg-bubbles-2"></div>
  </div>
</div>
